import { getExcelColumnName } from '../UrlExcelMapper/UrlExcelMapper.types'

export const formatColumnNumber = (columnNumber: string) => {
  const value = Number(columnNumber)
  return Number.isInteger(value) && value >= 1
    ? `${getExcelColumnName(value - 1)} (${value})`
    : columnNumber
}
